const en = {
    app: {
        nav: {
            navigation: "Navigation",
            websites: "Websites",
            mobileapps: "Mobile Apps",
            maintenance: "Maintenance",
            solutions: "Solutions",
            story: "Our story",
            contact: "Contact",
            privacy: "Privacy policy",
            other: "Other",
        },
        contact: {
            title: "Are you interested?",
            text: "Do you want to ask something, make an offer or anything else? Please do not hesitate to contact us!",
            button: "Contact us",
        },
    },
    home_page: {
        header: {
            title: "Your dream, our solution",
            text: "",
        },
        about: {
            title: "What is Verkkolabra?",
            text: "Verkkolabra is a digital agency with roots in Finland. We are offering a list of digital services or products. Our main goal is to challenge ourselves and create something meaningfull. " +
            "We create solutions that help our customers to grow their business.",
        },
        services: {
            title: "Our services",
            button: "View more",
            website: {
                title: "Websites",
            },
            mobileapps: {
                title: "Mobile Apps",
            },
            maintenance: {
                title: "Maintenance",
            },
        },
        steps: {
            title: "Development process",
            step1: {
                title: "The idea",
                text: "You have something awesome in your mind. We discuss about your idea and figure out new ways to make it even better.",
            },
            step2: {
                title: "We create it",
                text: "We start the production using the best technologies for the project. You can ask anything as often you want.",
            },
            step3: {
                title: "Finish",
                text: "We introduce the completed project and help you get started.",
            }
        },
        technologies: {
            title: "Technologies we love",
        },
    },
    websites_page: {
        header: {
            title: "Websites",
            text: "Websites are business card of the company. They make it easier for customers to reach your service." +
            "We design an unique style for your website so you will convince your customers.",
        },
        info: {
            title: "",
            section1: {
                title: "Visibility in search engines",
                text: "It's very important that your website can be accessed from search engines. Our websites are using modern technologies which allows search engines to find the website easier.",
            },
            section2: {
                title: "Responsive websites",
                text: "Every website we create, is responsive. Part of mobile users in internet is over 50 percent. Every website should definitely be responsive.",
            },
            section3: {
                title: "Content management system",
                text: "Our websites can be integrated with content management system. This system allows you to easily modify the content of the website. The only option is Wordpress at the moment.",
            },
        },
    },
    mobileapps_page: {
        header: {
            title: "Mobile Apps",
            text: "Our mobile apps are cheap and easy to scale. One app supports Android and iOS devices.",
        },
        info: {
            title: "",
            section1: {
                title: "One app, two platforms",
                text: "People are different as their phones. Android and iOS devices usually need their own apps. We create our mobile apps to work in both platforms so you pay only for one app.",
            },
            section2: {
                title: "Cheap and scalable",
                text: "Mobile apps usually need an storage. We use Google's Firebase so your app is easy to scale and is very affordable. You can also view app analytics using Firebase.",
            },
        },
    },
    maintenance_page: {
        header: {
            title: "Maintenance",
            text: "Website updates, server maintaining and hosting.",
        },
        info: {
            title: "",
            section1: {
                title: "Website updates",
                text: "Does your website need a new picture or a whole new style? If you want to focus the things you love insdead of updating your website, you can let us to do it.",
            },
            section2: {
                title: "Servers",
                text: "Do you have a server to maintain? Servers can sometimes be very tricky. That's why we offer our knowledge to handle the problems.",
            },
            section3: {
                title: "Hosting",
                text: "Along the development services we offer hosting services. If you need a web hotel, game server or vps we recommend you to take a look at solutions section.",
            },
        },
    },
    solutions_page: {
        header: {
            title: "Our solutions",
            text: "We are developing our own solutions along the customer projects. Here is a list of our solutions.",
        },
        info: {
            button: "View more",
            solution1: "Hosting",
        }
    },
    story_page: {
        header: {
            title: "Our story",
            text: "Everyone has always a story. Here is the story of how Verkkolabra originated.",
        },
        info: {
            text: "Idea of Verkkolabra became at start of 2017. One of the programmers wanted to move forward in his freelancer career. <br><br>" +
            "Figuring out the name was a long process. There was tens of options and they were voted with friends. " +
            "Finally we decided to pick Verkkolabra. The word 'Verkko' refered to 'Web' and 'Labra' (Lab) came from the depths of the mind.<br><br>" +
            "At the start Verkkolabra was selling websites and plugins for game called Minecraft. After six months Minecraft plugins remained behind and we began invest our time to websites, mobile apps and servers. " +
            "Our services have been almost the same since 2017. In the future we are going to invest time to our own products and services along the customer projects.",
        }
    },
    contact_page: {
        header: {
            title: "Contact",
            text: "Do you want to ask something, make an offer or anything else? Please do not hesitate to contact us!",
        },
        form: {
            name: "Name",
            email: "E-Mail",
            phone: "Phone number",
            message: "Message",
            button: "Send message",
            feedback_success: "Thank you for contacting us. We'll contact you back as soon as possible.",
            feedback_error: "Something went wrong. You can also contact us by email contact@verkkolabra.com",
        },
        team: {
            title: "Our team",
        }
    },
    privacy_page: {
        header: {
            title: "Register and Privacy Policy",
            text: "Tämä on Verkkolabra Oy:n asiakasrekisterin henkilötietolain (10 ja 24 §) ja EU:n yleisen tietosuoja-asetuksen (GDPR) mukainen rekisteri- ja tietosuojaseloste. Laadittu 16.6.2019. Viimeisin muutos 16.6.2019.",
        },
        content: "<h3><strong>1. Rekisterinpitäjä</strong></h3>\n" +
        "<p>Verkkolabra Oy, 90250 Oulu Suomi.<br> p. +358 44 212 9464<br>&nbsp;</p>\n" +
        "<h3><strong>2. Rekisteristä vastaava yhteyshenkilö</strong></h3>\n" +
        "<p>Arttu Pesonen, <a href=\"mailto:contact@verkkolabra.com\">contact@verkkolabra.com</a></p>\n" +
        "<h3><strong>3. Rekisterin nimi</strong></h3>\n" +
        "<p>Verkkolabra Oy asiakasrekisteri<br>&nbsp;</p>\n" +
        "<h3><strong>4. Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</strong></h3>\n" +
        "<p>EU:n yleisen tietosuoja-asetuksen mukainen oikeusperuste henkilötietojen käsittelylle on<br> rekisterinpitäjän\n" +
        "    oikeutettu etu (asiakassuhde).</p>\n" +
        "<p>Henkilötietojen käsittelyn tarkoitus on&nbsp;palvelun toimittaminen, asiakassuhteen ylläpito ja markkinointi.</p>\n" +
        "<p>Tietoja ei käytetä automatisoituun päätöksentekoon tai profilointiin.<br>&nbsp;</p>\n" +
        "<h3><strong>5. Rekisterin tietosisältö</strong></h3>\n" +
        "<p>Rekisteriin tallennettavia tietoja ovat:&nbsp;henkilön nimi, asema, yritys/organisaatio, yhteystiedot\n" +
        "    (puhelinnumero, sähköpostiosoite, osoite), www-sivustojen osoitteet, verkkoyhteyden IP-osoite,\n" +
        "    tunnukset/profiilit sosiaalisen median palveluissa, tiedot tilatuista palveluista ja niiden muutoksista,\n" +
        "    laskutustiedot, muut asiakassuhteeseen ja tilattuihin palveluihin liittyvät tiedot.</p>\n" +
        "<p>Tietoja säilytetään niin kauan kuin asiakassuhde on voimassa. Tarpeettomat tiedot poistetaan 2 vuoden välein.<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>6. Säännönmukaiset tietolähteet</strong></h3>\n" +
        "<p>Rekisteriin tallennettavat tiedot saadaan asiakkaalta mm. www-lomakkeilla lähetetyistä viesteistä, sähköpostitse,\n" +
        "    puhelimitse, sosiaalisen median palvelujen kautta, sopimuksista, asiakastapaamisista ja muista tilanteista,\n" +
        "    joissa asiakas luovuttaa tietojaan.<br>&nbsp;</p>\n" +
        "<h3><strong>7. Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle</strong></h3>\n" +
        "<p>Tietoja ei luovuteta säännönmukaisesti muille tahoille. Tietoja voidaan julkaista siltä osin kuin niin on sovittu\n" +
        "    asiakkaan kanssa.</p><br>\n" +
        "<h3><strong>8. Rekisterin suojauksen periaatteet</strong></h3>\n" +
        "<p>Rekisterin käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan\n" +
        "    asianmukaisesti. Kun rekisteritietoja säilytetään Internet-palvelimilla, niiden laitteiston fyysisestä ja\n" +
        "    digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti. Rekisterinpitäjä huolehtii siitä, että tallennettuja\n" +
        "    tietoja sekä palvelimien käyttöoikeuksia ja muita henkilötietojen turvallisuuden kannalta kriittisiä tietoja\n" +
        "    käsitellään luottamuksellisesti ja vain niiden työntekijöiden toimesta, joiden työnkuvaan se kuuluu.<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>9. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</strong></h3>\n" +
        "<p>Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia\n" +
        "    mahdollisen virheellisen tiedon korjaamista tai puutteellisen tiedon täydentämistä. Mikäli henkilö haluaa\n" +
        "    tarkistaa hänestä tallennetut tiedot tai vaatia niihin oikaisua, pyyntö tulee&nbsp;lähettää kirjallisesti&nbsp;rekisterinpitäjälle.\n" +
        "    Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä\n" +
        "    vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>10. Muut henkilötietojen käsittelyyn liittyvät oikeudet</strong></h3>\n" +
        "<p>Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien henkilötietojen poistamiseen rekisteristä\n" +
        "    (\"oikeus tulla unohdetuksi\"). Niin ikään rekisteröidyillä on muut&nbsp;EU:n yleisen tietosuoja-asetuksen\n" +
        "    mukaiset oikeudet&nbsp;kuten henkilötietojen käsittelyn rajoittaminen tietyissä tilanteissa. Pyynnöt tulee&nbsp;lähettää\n" +
        "    kirjallisesti&nbsp;rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan\n" +
        "    henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa\n" +
        "    (pääsääntöisesti kuukauden kuluessa).<br>&nbsp;</p>",
    },
};

const fi = {
    app: {
        nav: {
            navigation: "Navigointi",
            websites: "Verkkosivut",
            mobileapps: "Mobiilisovellukset",
            maintenance: "Huolenpito",
            solutions: "Ratkaisut",
            story: "Tarina",
            contact: "Yhteydenotto",
            privacy: "Tietosuojaseloste",
            other: "Muuta",
        },
        contact: {
            title: "Kiinnostuitko?",
            text: "Haluatko kysyä jotakin, tehdä tarjouksen tai jotain muuta? Älä epäröi ottaa meihin yhteyttä!",
            button: "Ota yhteyttä",
        },
    },
    home_page: {
        header: {
            title: "Sinun unelma, meidän ratkaisu",
            text: "",
        },
        about: {
            title: "Mikä on Verkkolabra?",
            text: "Verkkolabra on suomalainen digitoimisto. Tarjoamme digitaalisia palveluita ja tuotteita. Tavoitteemme on haaste itseämme ja luoda jotain merkityksellistä. " +
            "Pyrimmä auttamaan asiakkaitamme kasvattamaan heidän liiketoimintaa.",
        },
        services: {
            title: "Palvelut",
            button: "Katso lisää",
            website: {
                title: "Verkkosivut",
            },
            mobileapps: {
                title: "Mobiilisovellukset",
            },
            maintenance: {
                title: "Huolenpito",
            },
        },
        steps: {
            title: "Kehitysprosessi",
            step1: {
                title: "Idea",
                text: "Sinulla on jokin mahtava idea mielessä. Keskustelemme ideasta ja kehitämme ideaa eteenpäin.",
            },
            step2: {
                title: "Toteutus",
                text: "Aloitamme toteutuksen käyttäen parhaita mahdollisia teknologioita projektillesi. Voit kysyä projektista milloin tahansa.",
            },
            step3: {
                title: "Valmista",
                text: "Esittelemme sinulle valmiin projektin ja autamme sinut alkuun.",
            }
        },
        technologies: {
            title: "Käytämme näitä teknologioita",
        },
    },
    websites_page: {
        header: {
            title: "Verkkosivut",
            text: "Verkkosivut ovat yrityksen käyntikortti. Niiden avulla asiakkaiden on helppo löytää palvelusi. " +
            "Suunnittelemme uniikin tyylin verkkosivuillesi, jolloin erotut varmasti joukosta.",
        },
        info: {
            title: "",
            section1: {
                title: "Hakutulosten kärkeen",
                text: "On erittäin tärkeää, että verkkosivu löytyy hakukoneista. Käytämme verkkosivuissamme moderneja ratkaisuja, jolloin hakukoneet löytävät sivusi helpommin.",
            },
            section2: {
                title: "Responsiivisuus",
                text: "Jokainen toteuttamamme verkkosivu on yhteensopiva kaikilla laitteilla. Yli 50 prosenttia internetin käyttäjistä käyttää älypuhelinta internetin selaamiseen. " +
                "Tämän vuoksi verkkosivun täytyy olla responsiivinen.",
            },
            section3: {
                title: "Julkaisujärjestelmä",
                text: "Verkkosivumme voidaan liittää julkaisujärjestelmään. Kyseinen järjestelmä mahdollistaa sivun sisällön muokkauksen. Tällä hetkeä ainoa vaihtoehto on Wordpress.",
            },
        },
    },
    mobileapps_page: {
        header: {
            title: "Mobiilisovellukset",
            text: "Mobiilisovelluksemme ovat edullisia ja helppoja laajentaa. Yksi sovellus tukee Android ja iOS -laitteita.",
        },
        info: {
            title: "",
            section1: {
                title: "Yksi sovellus, kaksi alustaa",
                text: "Ihmiset ovat erilaisia niin kuin heidän puhelimensakin. Android ja iOS -laitteet tarvitsevat omat sovelluksensa. " +
                "Meidän mobiilisovellukset toimivat molemmilla laitteilla, joten maksat vain yhdestä sovelluksesta.",
            },
            section2: {
                title: "Edullinen ja helposti laajennettava",
                text: "Mobiilisovellukset tarvitsevat yleensä palvelimen. Käytämme Googlen Firebasea, jolloin sovelluksen ylläpito sekä laajennus on edullista ja helppoa. " +
                "Firebasen avulla voit myös tarkastella sovelluksen tilastoja.",
            },
        },
    },
    maintenance_page: {
        header: {
            title: "Huolenpito",
            text: "Verkkosivujen päivitys, palvelimien ylläpito sekä hostauspalvelut.",
        },
        info: {
            title: "",
            section1: {
                title: "Verkkosivun päivitäminen",
                text: "Tarvitseeko verkkosivusi uuden kuvan tai täysin uuden tyylin? Jos haluat keskittyä siihen mihin haluat, hoidamme sivujen päivittämisen puolestasi.",
            },
            section2: {
                title: "Palvelimet",
                text: "Onko sinulla palvelin ylläpidettävänä. Palvelimet ovat joskus oikukkaita. Tarjoamme osaamistamme helpottamaan sinua palvelimen ylläpitämisessä.",
            },
            section3: {
                title: "Hostaus",
                text: "Verkkosivujen ja muiden palvelujen ohella tarjoamme hostauspalveluita. Jos tarvitset web-hotellin, pelipalvelimen tai virtuaalipalvelimen, suosittelemme kurkkaamaan ratkaisut osioon.",
            },
        },
    },
    solutions_page: {
        header: {
            title: "Ratkaisut",
            text: "Kehitämme asiakasprojektien ohella omia ratkaisuja. Tässä lista omista ratkaisuistamme.",
        },
        info: {
            button: "Katso lisää",
            solution1: "Hostaus",
        }
    },
    story_page: {
        header: {
            title: "Tarina",
            text: "Jokaisella on aina jokin tarina. Tässä tarina siitä, miten Verkkolabra sai alkunsa.",
        },
        info: {
            text: "Idea Verkkolabraista lähti vuoden 2017 alussa. Yksi koodareista halusi nousta oman freelancer-uran seuraavalle askeleelle. Tästä lähti liikkelle Verkkolabran ideointi. <br><br>" +
            "Nimen ideointi oli pitkä prosessi. Vaihtoehtoja löytyi kymmeniä ja nimivaihtoehdoista äänestettiin kavereiden kesken. Lopulta päädyyttin Verkkolabraan, " +
            "koska 'Verkko' viittasi sanaan 'Web' ja labra tuli sitten mielen syvyyksistä.<br><br>" +
            "Verkkolabra myi aluksi verkkosivuja sekä lisäosia Minecraft-peliin. Noin puolen vuoden jälkeen Minecraft-lisäosat jäivät taka-alalle ja alettiin panostamaan verkkosivuihin, mobiilisovelluksiin ja palvelimiin." +
            "Tarjotanta ei siis juurikaan ole muuttunut sitten vuoden 2017.<br><br>Vuoden 2019 alussa tajuttiin, että Verkkolabra halutaan viedä kansainvälisille markkinoille. Tulevaisuudessa panostamme asiakasprojektien ohella omiin tuotteisiin ja ratkaisuihin.",
        }
    },
    contact_page: {
        header: {
            title: "Yhteydenotto",
            text: "Haluatko tehdä kysyä jotakin, tehdä tarjouksen tai jotain aivan muuta? Älä epäröi ottaa meihin yhteyttä!",
        },
        form: {
            name: "Nimi",
            email: "Sähköposti",
            phone: "Puhelinnumero",
            message: "Viesti",
            button: "Lähetä viesti",
            feedback_success: "Kiitos yhteydenotostasi. Otamme sinuun yhteyttä mahdollisimman pian.",
            feedback_error: "Jotain meni vikaan! Voit ottaa meihin yhteyttä myös sähköpostitse contact@verkkolabra.com",
        },
        team: {
            title: "Meidän tiimi",
        }
    },
    privacy_page: {
        header: {
            title: "Rekisteri- ja tietosuojaseloste",
            text: "Tämä on Verkkolabra Oy:n asiakasrekisterin henkilötietolain (10 ja 24 §) ja EU:n yleisen tietosuoja-asetuksen (GDPR) mukainen rekisteri- ja tietosuojaseloste. Laadittu 16.6.2019. Viimeisin muutos 16.6.2019.",
        },
        content: "<h3><strong>1. Rekisterinpitäjä</strong></h3>\n" +
        "<p>Verkkolabra Oy, 90250 Oulu Suomi.<br> p. +358 44 212 9464<br>&nbsp;</p>\n" +
        "<h3><strong>2. Rekisteristä vastaava yhteyshenkilö</strong></h3>\n" +
        "<p>Arttu Pesonen, <a href=\"mailto:contact@verkkolabra.com\">contact@verkkolabra.com</a></p>\n" +
        "<h3><strong>3. Rekisterin nimi</strong></h3>\n" +
        "<p>Verkkolabra Oy asiakasrekisteri<br>&nbsp;</p>\n" +
        "<h3><strong>4. Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</strong></h3>\n" +
        "<p>EU:n yleisen tietosuoja-asetuksen mukainen oikeusperuste henkilötietojen käsittelylle on<br> rekisterinpitäjän\n" +
        "    oikeutettu etu (asiakassuhde).</p>\n" +
        "<p>Henkilötietojen käsittelyn tarkoitus on&nbsp;palvelun toimittaminen, asiakassuhteen ylläpito ja markkinointi.</p>\n" +
        "<p>Tietoja ei käytetä automatisoituun päätöksentekoon tai profilointiin.<br>&nbsp;</p>\n" +
        "<h3><strong>5. Rekisterin tietosisältö</strong></h3>\n" +
        "<p>Rekisteriin tallennettavia tietoja ovat:&nbsp;henkilön nimi, asema, yritys/organisaatio, yhteystiedot\n" +
        "    (puhelinnumero, sähköpostiosoite, osoite), www-sivustojen osoitteet, verkkoyhteyden IP-osoite,\n" +
        "    tunnukset/profiilit sosiaalisen median palveluissa, tiedot tilatuista palveluista ja niiden muutoksista,\n" +
        "    laskutustiedot, muut asiakassuhteeseen ja tilattuihin palveluihin liittyvät tiedot.</p>\n" +
        "<p>Tietoja säilytetään niin kauan kuin asiakassuhde on voimassa. Tarpeettomat tiedot poistetaan 2 vuoden välein.<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>6. Säännönmukaiset tietolähteet</strong></h3>\n" +
        "<p>Rekisteriin tallennettavat tiedot saadaan asiakkaalta mm. www-lomakkeilla lähetetyistä viesteistä, sähköpostitse,\n" +
        "    puhelimitse, sosiaalisen median palvelujen kautta, sopimuksista, asiakastapaamisista ja muista tilanteista,\n" +
        "    joissa asiakas luovuttaa tietojaan.<br>&nbsp;</p>\n" +
        "<h3><strong>7. Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle</strong></h3>\n" +
        "<p>Tietoja ei luovuteta säännönmukaisesti muille tahoille. Tietoja voidaan julkaista siltä osin kuin niin on sovittu\n" +
        "    asiakkaan kanssa.</p><br>\n" +
        "<h3><strong>8. Rekisterin suojauksen periaatteet</strong></h3>\n" +
        "<p>Rekisterin käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan\n" +
        "    asianmukaisesti. Kun rekisteritietoja säilytetään Internet-palvelimilla, niiden laitteiston fyysisestä ja\n" +
        "    digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti. Rekisterinpitäjä huolehtii siitä, että tallennettuja\n" +
        "    tietoja sekä palvelimien käyttöoikeuksia ja muita henkilötietojen turvallisuuden kannalta kriittisiä tietoja\n" +
        "    käsitellään luottamuksellisesti ja vain niiden työntekijöiden toimesta, joiden työnkuvaan se kuuluu.<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>9. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</strong></h3>\n" +
        "<p>Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia\n" +
        "    mahdollisen virheellisen tiedon korjaamista tai puutteellisen tiedon täydentämistä. Mikäli henkilö haluaa\n" +
        "    tarkistaa hänestä tallennetut tiedot tai vaatia niihin oikaisua, pyyntö tulee&nbsp;lähettää kirjallisesti&nbsp;rekisterinpitäjälle.\n" +
        "    Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä\n" +
        "    vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).<br>&nbsp;\n" +
        "</p>\n" +
        "<h3><strong>10. Muut henkilötietojen käsittelyyn liittyvät oikeudet</strong></h3>\n" +
        "<p>Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien henkilötietojen poistamiseen rekisteristä\n" +
        "    (\"oikeus tulla unohdetuksi\"). Niin ikään rekisteröidyillä on muut&nbsp;EU:n yleisen tietosuoja-asetuksen\n" +
        "    mukaiset oikeudet&nbsp;kuten henkilötietojen käsittelyn rajoittaminen tietyissä tilanteissa. Pyynnöt tulee&nbsp;lähettää\n" +
        "    kirjallisesti&nbsp;rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan\n" +
        "    henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa\n" +
        "    (pääsääntöisesti kuukauden kuluessa).<br>&nbsp;</p>",
    },
};

export let lang = en;

export const setLang = function (value) {
    if (value === 0)
        lang = en;
    if (value === 1)
        lang = fi;
    else
        lang = en;
};

